<template>
  <div :class="showAvatar ? 'outer-message-wrapper' : ''" class="message-margin">
    <div :class="outgoingMessage ? 'outgoing-message-header' : 'incoming-message-header'">
      <div v-if="showAvatar" class="avatar"></div>
      <div
        :class="[
          outgoingMessage ? 'outgoing-message-wrapper' : 'incoming-message-wrapper',
          showTypingIndicator ? 'typing-indicator-wrapper' : '',
        ]"
      >
        <p
          :class="outgoingMessage ? 'message-text-outgoing' : 'message-text-incoming'"
          class="message-margin"
          :style="outgoingMessage ? $styles.outgoingMessage() : $styles.incomingMessage()"
        >
          <TypingIndicator v-if="showTypingIndicator" />
          {{ message }}
        </p>
      </div>
    </div>
    <FormattedTimestamp :showAvatar="showAvatar" :outgoingMessage="outgoingMessage" :timestamp="timestamp" />
  </div>
</template>

<script>
import TypingIndicator from './utils/TypingIndicator.vue'
import FormattedTimestamp from './utils/FormattedTimestamp.vue'
export default {
  props: {
    message: {
      type: String,
      default: '',
    },
    showAvatar: {
      type: Boolean,
      default: false,
    },
    showTypingIndicator: {
      type: Boolean,
      default: false,
    },
    outgoingMessage: {
      type: Boolean,
      default: false,
    },
    timestamp: {
      type: Number,
      default: +new Date(),
    },
  },
  components: {
    TypingIndicator,
    FormattedTimestamp,
  },
  methods: {
    selected() {
      this.$emit('conversation-selected', this.sid)
    },
  },
}
</script>

<style scoped>
.incoming-message-wrapper {
  color: #000000;
  background-color: #e5e5e5;
  width: 75%;
  border-radius: 6px;
  display: flex;
}

.outgoing-message-wrapper {
  display: flex;
  justify-content: flex-end;
}

.message-text-incoming {
  padding: 10px 15px;
}

.message-text-outgoing {
  padding: 10px 15px;
  margin-left: 0;
  margin-right: 0;
  border-radius: 6px;
  max-width: 75%;
  word-wrap: break-word;
}

.message-margin {
  margin-top: 0;
  margin-bottom: 0px;
}

.outer-message-wrapper {
  color: rgb(34, 34, 34);
  margin-bottom: 10px;
}

.outgoing-message-header {
  display: block;
}

.incoming-message-header {
  display: flex;
}

.avatar {
  background-image: url('https://cdn0.traderinteractive.com/user_avatar.svg');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: 50%;
  min-width: 30px;
  min-height: 30px;
  border-radius: 50%;
  align-self: center;
  margin-right: 15px;
}

.typing-indicator-wrapper {
  width: 25%;
  justify-content: center;
}
</style>
